export class TransactionProductUnitPrice {
  public productID: number;
  public modifier: number;
  public priceLevel: number;
  public value: number;

  constructor(productId?: number, value?: number, modifier?: number, priceLevel?: number) {
    this.productID = productId;
    this.value = value;
    this.modifier = modifier;
    this.priceLevel = priceLevel;
  }
}
